import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "text-center pb-4" }
const _hoisted_3 = {
  key: 0,
  class: "col pt-2 advanced-options"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "pt-4" }
const _hoisted_6 = { class: "pt-2 pb-2" }
const _hoisted_7 = { class: "px-1" }
const _hoisted_8 = {
  key: 0,
  class: "pt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MealTable = _resolveComponent("MealTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"text-center pt-4\"><h1><a href=\"https://dining.brown.edu/meal-plans/#meal-plan-options\" rel=\"noopener\" target=\"_blank\">Brown Meal Plans</a></h1><h2>Are they worth it? Probably not :(</h2></div><h2>Meal Plans</h2><p> This site was created to increase transparency about Brown meal plans and to help in deciding if they are worth it for you. </p><p> Edit 08/08/23: Add settings to account for missed meals and to ignore flex points (because most people use flex points at e.g. the blue room and not the ratty/vdub, which is equivalent to bear buck use and can therefore be ignored; shows Flex 70 is thus a horrendous deal) </p><div id=\"how-to\"><h2>How to use</h2><ol><li>Find a meal plan that gives you enough swipes per week</li><li>Look at the ratty ratio</li><li> If you do not go to the ratty or vdub at least that percent of the time, you will save money buying dining hall meals with bear bucks instead of being on meal plan! <ul><li> If the ratio is above 1, then you&#39;re likely being scammed by Brown—you still lose money even if all your swipes are at the ratty/vdub! </li><li> Note: the default calculation assumes you are equally likely to get ratty breakfast as dinner. However, if you will only go to the ratty for the most expensive mealtimes (i.e. dinner), use the max cost option for ratty cost in advanced settings </li></ul></li><li> If the cost per meal is more than your favorite Thayer restaurant, then you&#39;ll save money eating on Thayer every day. </li></ol></div>", 5)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAdvanced = !_ctx.showAdvanced)),
        class: "btn btn-secondary"
      }, _toDisplayString(_ctx.showAdvanced ? "Hide" : "Show") + " Advanced Settings", 1),
      (_ctx.showAdvanced)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                for: "ratty-cost-selector",
                class: "pr-1"
              }, "Ratty Cost Calculation (see ratty ratio section in more calculation details for further info):", -1)),
              _withDirectives(_createElementVNode("select", {
                id: "ratty-cost-selector",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rattyCost) = $event))
              }, [...(_cache[5] || (_cache[5] = [
                _createElementVNode("option", { value: "avg" }, "Average cost", -1),
                _createElementVNode("option", { value: "max" }, "Max cost", -1)
              ]))], 512), [
                [_vModelSelect, _ctx.rattyCost]
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                id: "ignore-flex",
                type: "checkbox",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ignoreFlex) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.ignoreFlex]
              ]),
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "ignore-flex",
                class: "pl-1"
              }, "Do not use flex credits as meal swipes", -1))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[8] || (_cache[8] = _createTextVNode(" Account for missed meals: I plan to eat only ", -1)),
              _createElementVNode("span", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  min: "0",
                  max: "21",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.plannedMealsPerWk) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.plannedMealsPerWk]
                ])
              ]),
              _cache[9] || (_cache[9] = _createTextVNode(" meals per week at dining halls ", -1))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_MealTable, {
      plans: _ctx.plans,
      rattyCost: _ctx.rattyCost,
      ignoreFlex: _ctx.ignoreFlex,
      plannedMealsPerWk: _ctx.plannedMealsPerWk
    }, null, 8, ["plans", "rattyCost", "ignoreFlex", "plannedMealsPerWk"]),
    _createElementVNode("div", null, [
      _cache[14] || (_cache[14] = _createElementVNode("h2", null, "My Commentary 🙃", -1)),
      _createElementVNode("ul", null, [
        _cache[11] || (_cache[11] = _createElementVNode("li", null, " Calculations assume you use every single meal, including guest swipes. If you don't, you're getting an even worse deal. Experiment with this in advanced settings! ", -1)),
        _cache[12] || (_cache[12] = _createElementVNode("li", null, "You must go to the ratty/vdub with non-negligible frequency for meal plans to be worth it (peep the ratty ratio!)", -1)),
        _createElementVNode("li", null, [
          _cache[10] || (_cache[10] = _createTextVNode(" Paying for all dining hall meals with bear bucks (instead of meal plan) is a highly underrated option. Bear bucks costs are: ", -1)),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, "Normal swipe (andrews/jo's): $" + _toDisplayString(_ctx.SWIPE_COST), 1),
            _createElementVNode("li", null, "All you can eat swipes (ratty/vdub): $" + _toDisplayString(_ctx.BREAKFAST_AYCE_COST) + " (breakfast), $" + _toDisplayString(_ctx.LUNCH_AYCE_COST) + " (lunch), and $" + _toDisplayString(_ctx.DINNER_AYCE_COST) + " (dinner)", 1)
          ])
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("li", null, " If you're okay avoiding the ratty/vdub, you will save obscene amounts of money 🤑 🤑 🤑 by paying with bear bucks, poaching swipes off of friends, and even eating out on Thayer at cheaper places like Chipotle! And you still don't even have to cook a single meal the whole semester! ", -1))
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-danger",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showExtended = !_ctx.showExtended))
    }, _toDisplayString(_ctx.showExtended ? 'Hide' : 'Show') + " More Calculation Details", 1),
    (_ctx.showExtended)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _cache[17] || (_cache[17] = _createElementVNode("h2", null, "Calculation Details", -1)),
          _cache[18] || (_cache[18] = _createElementVNode("ul", null, [
            _createElementVNode("li", null, "Meals per wk = meal credits + guest credits + (flex points / cost per swipe)"),
            _createElementVNode("li", null, "Cost per meal = cost per semester / (meals per wk * 15 wks)"),
            _createElementVNode("li", null, [
              _createTextVNode(" Ratty ratio solves for rr in: rr * ratty cost + (1 - rr) * 11.25 = meal cost "),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, "Average (default): use ratty cost = avg(ratty breakfast + ratty lunch + ratty dinner)"),
                _createElementVNode("li", null, " Max: iterates through 0 to 20 meals at ratty per week, calculating the ratty cost by assuming the first 7 meals to be ratty dinners, then the next 7 to be lunches, then the next to be breakfasts. Terminates once we break even. An iterative solution instead of numerical because the ratty cost changes in a piecewise manner. ")
              ])
            ]),
            _createElementVNode("li", null, " Planned meals per week setting: limits the meals per week, keeping the same overall price but changing the cost per meal and ratty ratio. ")
          ], -1)),
          _cache[19] || (_cache[19] = _createElementVNode("h2", null, "Cost of swipes (2023-2024)", -1)),
          _createElementVNode("ul", null, [
            _cache[16] || (_cache[16] = _createElementVNode("li", null, "Retail eateries (andrews, jo's, etc.): $11.25", -1)),
            _createElementVNode("li", null, [
              _cache[15] || (_cache[15] = _createTextVNode(" All you can eat eateries (ratty, vdub): ", -1)),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, "Swipe with flex points: $" + _toDisplayString(_ctx.SWIPE_COST), 1),
                _createElementVNode("li", null, "Breakfast with bear bucks: $" + _toDisplayString(_ctx.BREAKFAST_AYCE_COST), 1),
                _createElementVNode("li", null, "Lunch with bear bucks: $" + _toDisplayString(_ctx.LUNCH_AYCE_COST), 1),
                _createElementVNode("li", null, "Dinner with bear bucks: $" + _toDisplayString(_ctx.DINNER_AYCE_COST), 1)
              ])
            ])
          ]),
          _cache[20] || (_cache[20] = _createElementVNode("h3", null, "Additional Notes", -1)),
          _cache[21] || (_cache[21] = _createElementVNode("ul", null, [
            _createElementVNode("li", null, " Flex meal plans may be more worth it than the calculations show if many of your meals do not cost a full swipe "),
            _createElementVNode("li", null, [
              _createTextVNode(" You can purchase additional flex points through "),
              _createElementVNode("a", {
                href: "https://mycard.brown.edu/",
                rel: "noopener",
                target: "_blank"
              }, "my card"),
              _createTextVNode(" when on meal plan. This means additional ratty/vdub swipes can be purchased for only $11.25 ")
            ]),
            _createElementVNode("li", null, [
              _createTextVNode(" Let me know "),
              _createElementVNode("a", {
                href: "https://forms.gle/EZZMSx3SBMaBqbjf7",
                rel: "noopener",
                target: "_blank"
              }, "here"),
              _createTextVNode(" if you have any comments or feedback! ")
            ])
          ], -1))
        ]))
      : _createCommentVNode("", true)
  ]))
}